export default __webpack_public_path__ + "bebb130b915e9393f998d58db4b6508d.png";